export type LogoProps = {
  /** Rendered height in pixels. Width scales automatically with the image aspect ratio. */
  size?: number;
};

export function Logo({ size = 24 }: LogoProps) {
  return (
    <img
      src="/branding/logo-ninon.png"
      alt="Optiek NINON"
      height={size}
      style={{
        height: size,
        width: 'auto',
        display: 'block',
        userSelect: 'none',
        // The source asset has a small amount of internal whitespace; a touch
        // of optical alignment keeps the wordmark from drifting upward.
        transform: 'translateY(0.5px)',
      }}
      draggable={false}
    />
  );
}
